module.exports = __webpack_public_path__ + "static/new-email-mobile-d8c61e811df8b72e5a06cb4ea24d9c35.jpg";